export default {
    "title": "Documentation / {{client}}",
    "availableDocuments": "Available documents",
    "document": "Document: ",
    "download": "Download",
    "startDate": "Start date: ",
    "endDate": "Expiration date: "
}